import React, { useState } from 'react';
import {connect, useDispatch} from 'react-redux';
import {createSelector} from 'reselect';
import cx from 'classnames';
import {isEmpty} from "lodash";


import {yup, validateEmail} from "../utils/forms";

import User, {selectCurrentUser} from '../store/models/User';
import UIState from '../store/UIState';
import RouteState, {pushTo} from '../store/RouteState';

import Modal, {
  ModalTitle,
  ModalSubtitle,
  ModalActions,
  ModalContentStretch,
  ModalActionHelper,
  ModalHeader
} from "../components/Modal";
import TextInput from '../components/forms/TextInput';
import {ErrorList} from '../components/forms/Error';
import {FormSmall} from '../components/forms/Form';
import {Button} from "../components/Button";

const schema = yup.object().shape({
  email: validateEmail.required(),
});


const ForgotPasswordModal = ({onClose, onDone,...props}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState();
  const [errors, setErrors] = useState({});
  
  const onSubmit = async () => {
    try {
      setLoading(true);
      if (_.isEmpty(email)) {
        setLoading(false);
        setErrors({server: "Email cannot be empty"});
      }
      let values = await schema.validate({email});
      await dispatch(User.actions.requestResetPassword(values.email));
      setLoading(false);
      dispatch(UIState.actions.showSuccessToast("An email has been sent to you with instructions to reset your password"));
      dispatch(RouteState.actions.goToHome());
      onClose?.();
    } catch (err) {
      setLoading(false);
      setErrors({server: err.message});
    }
  };

  const onInputChange = (value, name) => setEmail(value);

  return (
    <Modal
      className={cx("request-reset-password")}
      size="s"
      onClose={onClose}>
      <FormSmall onSubmit={onSubmit}>
        <ModalHeader>
          <ModalTitle>Reset Your Password</ModalTitle>
          <ModalSubtitle>We'll email you a link to change your password</ModalSubtitle>
        </ModalHeader>
        <ModalContentStretch>
          <ErrorList errors={errors}/>
          <TextInput
            className="email-input"
            name="email"
            value={email}
            focused={true}
            placeholder={"Email"}
            onChange={onInputChange}/>
        </ModalContentStretch>
        <ModalActions>
          <Button
            className={"request-reset-password-btn"}
            size={"l"}
            submit={true}
            loading={loading}
            disabled={(isEmpty(email) || loading)}>
            Reset Password
          </Button>
        </ModalActions>
      </FormSmall>
    </Modal>);
}

export default ForgotPasswordModal;

